import { PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_CLIENT_ID ?? '';
const tenantId = process.env.REACT_APP_TENANT_ID ?? '';
const redirectUri = process.env.REACT_APP_REDIRECT_URI ?? '/';
const authority = `https://login.microsoftonline.com/${tenantId}`;
export const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['User.Read'], // Escopo básico para ler o perfil do usuário
};

export const msalInstance = new PublicClientApplication(msalConfig);